import { render, staticRenderFns } from "./panel-item.vue?vue&type=template&id=48bfcc76&scoped=true"
import script from "./panel-item.vue?vue&type=script&lang=js"
export * from "./panel-item.vue?vue&type=script&lang=js"
import style0 from "./panel-item.vue?vue&type=style&index=0&id=48bfcc76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bfcc76",
  null
  
)

export default component.exports